import { unstable_usePrompt as usePrompt } from 'react-router-dom';
import type { BlockerFunction } from 'react-router-dom';

interface Props {
  readonly mustBlock: boolean | BlockerFunction;
  readonly message?: string;
}

const DEFAULT_MESSAGE =
  'Votre formulaire est en cours de modification. Souhaitez-vous réellement quitter la page ? Toutes les modifications non sauvegardées seront perdues.';

export { DEFAULT_MESSAGE as FORM_PROMPT_DEFAULT_MESSAGE };

export const FormPrompt = ({
  mustBlock,
  message = DEFAULT_MESSAGE,
}: Readonly<Props>) => {
  usePrompt({ message, when: mustBlock });

  return null;
};
